module.exports = __webpack_public_path__ + "static/media/template_deliveries.cc77ecf4.csv";